import * as yup from 'yup';

import { MitversicherterPartnerPropertySchema } from '@/features/Clients/Schemas/MitversicherterPartner';
import { hasMitversichertePerson } from '@/features/Contract/Shared/sharedConditions';
import type { AnyObjectSchema } from 'yup';

export const resMitversicherterPartnerSchema: AnyObjectSchema =
  MitversicherterPartnerPropertySchema.concat(
    yup.object({
      berufsgruppe: yup.string().when({
        is: () => hasMitversichertePerson.value,
        then: yup.string().required(),
      }),
      beruf: yup.string().when({
        is: () => hasMitversichertePerson.value,
        then: yup.string().required(),
      }),
    }),
  );
